/*
	Image Post Loader
	==================

	Postload all images in view that have the class ".lazyload".

	<img class="lazyload" data-source="myimage.png" />


	Note - CSS required to give smooth transition

	.lazyload {
		opacity: 0;
		transition: opacity .25s ease-in-out;
		-moz-transition: opacity .25s ease-in-out;
		-webkit-transition: opacity .25s ease-in-out;
	}
*/

define('imagePostLoader',[
  'jquery'
], function($){
  
  return {
		//
		// Img selector (must match css selector for fade-in effect)
		imgSelector: ".postload",
		//
		// Offset in pixels
		lazyLoadOffset: 200,
		//
		// Added after image is loaded
		classImgLoaded: 'image-loaded',
		// 
		// The data attribute that contains the image path
		dataAttributeImageSource: 'imagePath',
		//
		//
		init: function() {
			var self = this;

			$(function () {
				//$(window).scroll(self.lazyimg, self);
				//$(window).resize(self.lazyimg, self);
				//self.lazyimg(self);
				self.loadAllImages();
			});

			return self;
		},
		//
		//	POC Lazy load images when in view
		//	Not complete.
		/*lazyimg: function(self) {

			console.log("lazyload searching...");

			$(self.imgSelector).filter(function() {
				var $thisImg = $(this);

				console.log("lazyload image filtering...");

				if ($thisImg.is(':visible') && (!$thisImg.hasClass(self.classImgLoaded))) {

					var windowTop			= $(window).scrollTop(),
						windowViewInPixels	= windowTop + $(window).height(),
						imgOffsetTop		= $thisImg.offset().top,
						imgViewInPixels		= imgOffsetTop + $thisImg.height();


					return	(imgViewInPixels >= windowTop - windowViewInPixels) && 
							(imgOffsetTop <= windowViewInPixels + self.lazyLoadOffset);

				}
			}).each(function() {
				var $this = $(this),
					imgToLoad = $this.data(self.dataAttributeImageSource);

				console.log("lazyload each:", $this);

				if (imgToLoad) {
					$this.attr('src', imgToLoad).addClass(self.classImgLoaded).show();
				}	
			});
		},*/

		loadAllImages: function() {
			var self = this;
			$(self.imgSelector).each(function(){
				var $this = $(this),
					imgToLoad = $this.data(self.dataAttributeImageSource);

				if (imgToLoad) {
					$this.attr('src', imgToLoad).addClass(self.classImgLoaded).show();
				}	
			});
		}

	};

});
